export const COLOR_SET = {
  white: '#fff',
  blue01: '#5061FA',
  blue02: '#7B90FF',
  blue03: '#B1BEFF',
  blue04: '#E7EDFF',
  blue05: '#F8FAFF',
  gray01: '#4D4E58',
  gray015: '#747580',
  gray02: '#8E9098',
  gray03: '#CACDD8',
  gray04: '#F1F2F5',
  gray045: '#F6F6F7',
  gray05: '#FBFBFB',
  red01: '#F1636F',
  red02: '#FCDBDE',
  green01: '#56cb77',
  green02: '#b6e5c3',
  yellow01: '#F6C375',
}

export const FONT_SIZE = {
  xxs: '10px',
  xs: '12px',
  sm: '14px',
  m: '16px',
  lg: '18px',
  xl: '20px',
  xxl: '22px',
  xxxl: '24px',
}

export const ICON_SIZE = {
  xxs: '12px',
  xs: '16px',
  sm: '20px',
  m: '24px',
  lg: '28px',
  xl: '32px',
  xxl: '36px',
}

export const FONT_WEIGHT = {
  thin: '100',
  regular: '400',
  bold: '700',
}
